import styled from 'styled-components';
import { Input } from 'antd';
import 'antd/es/input/style/index.js';

export const TextInput = styled(Input)``;
